module.exports = __webpack_public_path__ + "static/media/resume.f0788ee2.svg";